export enum DefLinksConditionsKey {
  PERMANENT = 'defLinksConditions',
}
